import React from "react";
import { Inbox } from "lucide-react";

const EmptyState = ({
	title = "No data available",
	message = "Nothing to show here yet. Check back after the next draw.",
	icon: Icon = Inbox,
	action = null,
}) => {
	return (
		<div className="flex w-full flex-col items-center justify-center gap-4 px-6 py-14 text-center">
			<div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-white/5">
				<Icon className="h-7 w-7 text-brand-periwinkle" aria-hidden="true" />
			</div>
			<h3 className="lb-heading text-2xl text-white sm:text-3xl">{title}</h3>
			<p className="max-w-md text-sm text-white/55">{message}</p>
			{action}
		</div>
	);
};

export default EmptyState;
